
export default function SubmissionGuidelines() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Libre Baskerville", serif' }}>
        Submission Guidelines
      </h2>
      
      <div className="space-y-8">
        {/* Welcome Message */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="font-semibold text-blue-800 mb-3">
            <i className="ri-heart-line mr-2"></i>
            We Welcome All Work
          </h3>
          <p className="text-blue-700 mb-4">
            We are excited to review submissions from writers of all backgrounds and experience levels. 
            Whether you're sharing poetry, fiction, essays, reviews, or other literary work, we'd love to read it.
          </p>
          <div className="bg-white border border-blue-200 rounded-md p-4">
            <h4 className="font-medium text-blue-800 mb-2">Preferred Formats:</h4>
            <div className="flex items-center space-x-6">
              <div className="flex items-center text-blue-700">
                <i className="ri-file-pdf-line text-lg mr-2"></i>
                <span className="font-medium">PDF</span>
              </div>
              <div className="flex items-center text-blue-700">
                <i className="ri-book-line text-lg mr-2"></i>
                <span className="font-medium">EPUB</span>
              </div>
            </div>
            <p className="text-sm text-blue-600 mt-2">
              These formats help us review your work in the best possible way.
            </p>
          </div>
        </div>

        {/* Simple Requirements */}
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
          <h3 className="font-semibold text-gray-900 mb-3">
            <i className="ri-information-line mr-2"></i>
            What We Need
          </h3>
          <ul className="space-y-2 text-gray-700">
            <li className="flex items-start">
              <i className="ri-check-line mt-0.5 mr-2 text-green-500 flex-shrink-0"></i>
              Your original work in PDF or EPUB format
            </li>
            <li className="flex items-start">
              <i className="ri-check-line mt-0.5 mr-2 text-green-500 flex-shrink-0"></i>
              A brief author bio
            </li>
            <li className="flex items-start">
              <i className="ri-check-line mt-0.5 mr-2 text-green-500 flex-shrink-0"></i>
              Your contact information
            </li>
          </ul>
        </div>

        {/* Review Process */}
        <div className="bg-green-50 border border-green-200 rounded-lg p-6">
          <h3 className="font-semibold text-green-800 mb-3">
            <i className="ri-time-line mr-2"></i>
            Review Process
          </h3>
          <p className="text-green-700 mb-3">
            Our editorial team carefully reviews each submission. We aim to respond within 8-12 weeks.
          </p>
          <p className="text-sm text-green-600">
            We appreciate your patience as we give each work the attention it deserves.
          </p>
        </div>

        {/* Contact Information */}
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <h3 className="font-semibold text-red-800 mb-3">
            <i className="ri-mail-line mr-2"></i>
            Questions?
          </h3>
          <p className="text-red-700 mb-2">
            Have questions about your submission? We're here to help.
          </p>
          <p className="text-sm text-red-600">
            <strong>Email:</strong> submissions@mapleleafreview.ca<br />
            <strong>Response time:</strong> We aim to respond to all queries within 48 hours
          </p>
        </div>
      </div>
    </div>
  );
}
